<template>
    <div>
        <div class="courses-not-available-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="cancelPayModal" aria-hidden="true">
            <div class="modal-dialog modal-pdv">
                <div class="modal-content">
                    <div class="modal-title">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="main-content">
                        <div class="row">
                            <div class="col text-content">
                                <img src="/images/iconos/error-pago.png" alt="">
                                <div v-if="coursesNotAvailables.length === 1">
                                    <h5>Lo sentimos!</h5>
                                    <h6>Los siguientes cursos se han quedado sin cupos.</h6>
                                    <div  v-for="(orderDetail,i) in coursesNotAvailables" :key="i">
                                        <b>
                                            {{orderDetail.student.name}}
                                        </b>
                                        <ul>
                                            <li v-for="subject in orderDetail.subjects" :key="subject.id">
                                                {{subject.name}}
                                            </li>
                                        </ul>
                                    </div>
                                     <button 
                                    type="button"
                                    data-dismiss="modal"
                                    @click="onContinue"
                                    class="btn-pdv-primary button">
                                        Continuar
                                    </button>
                                </div>
                                <div v-else>
                                    <h5>Lo sentimos!</h5>
                                    <h6>Disculpe pero alguno de los cursos seleccionados ha agotado su disponibilidad. Por favor intente de nuevo.</h6>
                                    <button 
                                    type="button"
                                    data-dismiss="modal"
                                    @click="onContinue"
                                    class="btn-pdv-primary button">
                                        Finalizar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapState } from 'vuex'
    export default {

        data(){
          return {

          }
        },

        computed:{
            ...mapState(['coursesNotAvailables']),
            selectedPack(){
                return JSON.parse(localStorage.getItem("pack"));
            }
        },

        components: {
        },

        methods:{
            onPay(){
                 this.$emit('onPay')
            },
            onContinue(){
                if(
                    this.coursesNotAvailables.length > 1
                ){
                     this.$router.push('/')
                }else{
                    if(this.selectedPack){
                        this.$router.push('/packpdv')
                        return
                    }
                    const student = this.$store.getters.lastStudent;
                    const coursesNotAvailables = this.coursesNotAvailables.find(x=>x.student.id === student.id)
                   
                   if(
                       coursesNotAvailables && 
                       coursesNotAvailables.subjects.every(c=>c.hasMore)
                   ){
   
                       this.$router.push('/inscripcion-paso-2')
   
                   }else{
   
                       this.$router.push('/inscripcion-paso-1')
   
                   }
                }
            }
        },
        watch : {
            coursesNotAvailables(val){
                console.log(val)
            }
        }


    }
</script>

<style scoped lang="scss">
    .courses-not-available-modal{
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            max-width: 951px;
            @include media-breakpoint-down(sm){
                margin: 65px 20px 0px 20px;
            }
            .modal-content{
                padding: 50px 100px;
                border-radius: 1px;
                border: 0.5px solid #000000;
                box-shadow: 0 0 12px 3px #00000038;
                @include media-breakpoint-down(sm){
                    padding: 28px 25px;
                }
                h5 {
                    margin-bottom: 0;
                    font-size: 20px;
                    line-height: 23px;
                    @include media-breakpoint-down(sm){
                        font-size: 16px;
                        text-align: center;
                        line-height: 23px;
                    }
                    font-weight: bold;
                }
                h6 {
                    margin-top: 10px;
                    margin-bottom: 30px;
                    font-size: 18px;
                    line-height: 24px;
                    @include alternative-regular;
                    @include media-breakpoint-down(sm){
                        text-align: center;
                        line-height: 24px;
                        font-size: 16px;
                        margin-bottom: 36px;
                    }
                }
                ul {
                    margin-top: 5px;
                    margin-bottom: 15px;
                    li {
                        color : #DC3545;
                        font-weight: bold;
                    }
                }
                .modal-title{
                    button.close{
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        opacity: 1;
                        span{
                            font-size: 30px;
                            color: $brown-light;
                        }
                    }
                }
                .main-content{
                    min-height: 350px;
                    display: flex;
                    align-items: center;
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        @include alternative-bold;
                    }
                    p {
                        font-size: 18px;
                        line-height: 26px;
                        @include alternative-regular;
                        margin-bottom: 19px;
                    }
                    .text-content {
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 30px;
                            width: 203px;
                        }
                        @include media-breakpoint-down(sm){
                            display: block;
                            text-align: center;
                            img{
                                margin-right: 0;
                                margin-bottom: 18px;
                                width: 146px;
                            }
                        }
                    }
                    .button {
                         @include media-breakpoint-up(sm){
                             width:160px;
                        }
                    }
                }

            }

        }
    }

</style>